<app-loading *ngIf="contentReady"></app-loading>
<div class="container-fluid p-0">
  <div>


    <div class="col-12 col-sm-12 main-content">
      <div class="container-fluid mb-4">
        <div class="categoryContainer">

          <div class="col-12">
            <button routerLink="/createclient" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'Create Client' | translate }}
            </button>
            <!-- <button (click)="exportToExcel()" class="btn first-btn btn-primary">
              {{ "export to excel" | translate }}
            </button> -->

            <button (click)="getAllClients(10, 1)" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'refresh' | translate }}
            </button>
            <div class="mb-3">
              <label>اختار نوع الحالة :</label>
              <select (change)="onVisaTypeChange($event)">
                <option value="">اختار</option>
                <option value="0">{{ 'Under procedure' | translate }}</option>
                <option value="1">{{ 'There is a problem' | translate }}</option>
                <option value="2">{{ "A visa has been issued" | translate }}</option>
              </select>


            </div>

            <div class="input-group mb-3">
              <input type="text" class="form-control" [(ngModel)]="searchKey"
                placeholder="{{ 'searchwith' | translate }}" aria-label="Recipient's username"
                aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="search()" type="button">{{ 'Search' | translate
                  }}</button>
              </div>
            </div>



          </div>
        </div>
        <div>
          <table mat-table id="Clients" [dataSource]="dataSource" class="mat-elevation-z8">

            <ng-container matColumnDef="name_en">
              <th mat-header-cell *matHeaderCellDef>{{ 'Name' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.name_en }}
                <br>
                <span style="color: red; font-size: 10px;">{{el.notes}}</span>

              </td>
            </ng-container>

            <ng-container matColumnDef="name_ar">
              <th mat-header-cell *matHeaderCellDef>{{ 'NameAr' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.name_ar }}
                <br>
                <span style="color: red; font-size: 10px;">{{el.notes}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="job">
              <th mat-header-cell *matHeaderCellDef>{{ 'job title' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.job }}</td>
            </ng-container>

            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef>{{ 'address' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.address }}</td>
            </ng-container>

            <ng-container matColumnDef="phone_number">
              <th mat-header-cell *matHeaderCellDef>{{ 'Phone Number' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.phone_number }}

                <br>
                {{ el.another_phone }}
              </td>
            </ng-container>





            <ng-container matColumnDef="internet_date">
              <th mat-header-cell *matHeaderCellDef>{{ 'internet date' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.internet_date | date }}</td>
            </ng-container>

            <ng-container matColumnDef="numbers">
              <th mat-header-cell *matHeaderCellDef>{{ 'details' | translate }}</th>
              <td mat-cell *matCellDef="let el">
                <b>{{ 'Passport' | translate }}</b>
                {{ el.passport_number }}

                <br>
                <b>{{ 'Visa Number' | translate }}</b>
                {{ el.visa_number }}

                <br>
                <b>{{ 'Record Number' | translate }}</b>
                {{ el.record_number }}

                <br>
                <b>{{ 'Request Number' | translate }}</b>
                {{ el.request_number }}
                <br>
                @if(el.status == 0){
                <span style="color: orange; font-size: 14px;">{{ 'Under procedure' | translate }}</span>
                }
                @else if(el.status == 1){
                <span style="color: red; font-size: 14px;">{{ 'There is a problem' | translate }}</span>
                }
                @else{
                <span style="color: green; font-size: 14px;">{{ "A visa has been issued" | translate }}</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="checks">
              <th mat-header-cell *matHeaderCellDef>متطلابات العميل</th>
              <td mat-cell *matCellDef="let el">
                {{ 'Lab' | translate }}
                @if(el.lab == 0 || el.lab == null) {

                <span>✖</span>
                }
                @else {
                <span>


                  ✔</span>
                }
                <br>
                {{ 'Hospital' | translate }}
                @if(el.hospital == 0 || el.hospital == null) {
                <span>

                  ✖</span>
                }
                @else {
                <span>


                  ✔</span>
                }
                <br>
                {{ 'fingerprint' | translate }}
                @if(el.fingerprint == 0 || el.fingerprint == null) {
                <span>

                  ✖</span>
                }
                @else {
                <span>


                  ✔</span>
                }
                <br>
                {{ 'Contract' | translate }}
                @if(el.contract == 0 || el.contract == null) {
                <span>

                  ✖</span>
                }
                @else {
                <span>


                  ✔</span>
                }
                <br>
                {{ 'Authorization' | translate }}
                @if(el.authorization == 0 || el.authorization == null) {
                <span>

                  ✖</span>
                }
                @else {
                <span>


                  ✔</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="representative">
              <th mat-header-cell *matHeaderCellDef>المندوب</th>
              <td mat-cell *matCellDef="let el">
                {{ el.representative}}
              </td>
            </ng-container>
            <ng-container matColumnDef="visatype">
              <th mat-header-cell *matHeaderCellDef>الفيزا</th>
              <td mat-cell *matCellDef="let el">

                @if(el.visa_type == "0"){
                <span style="color: brown; font-size: 14px;">
                  زيارة فرست جروب

                </span>
                }
                @else if(el.visa_type == "2"){

                <span style="color: green; font-size: 14px;">
                  فيزا عمل

                </span>
                }
                @else{
                <span style="color: blue; font-size: 14px;">

                  فيزا فرست جروب
                </span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="payment">
              <th mat-header-cell *matHeaderCellDef> مدفوعات</th>
              <td mat-cell *matCellDef="let el">
                المدفوع
                {{el.paid}}
                <br>
                المتبقي
                {{el.remaining}}

                @if(el.payment_status != 0){
                <br>
                طريقة الدفع

                @if(el.payment_method == 0){
                <span style="color: orange; font-size: 14px;">كاش</span>
                }
                @else if(el.status == 1){
                <span style="color: red; font-size: 14px;">انتساباي</span>
                }
                @else if(el.status == 2){
                <span style="color: blue; font-size: 14px;">محفظة الالكترونية</span>
                }
                @else{
                <span style="color: green; font-size: 14px;">تحويل بنكي</span>
                }
                }
                <br>
                حالة الدفع
                <br>
                @if(el.payment_status == 0){
                <span style="color: orange; font-size: 14px;">لم يتم الدفع</span>
                }
                @else if(el.status == 1){
                <span style="color: green; font-size: 14px;">مكتمل جزئي</span>
                }
                @else if(el.status == 2){
                <span style="color: blue; font-size: 14px;">مكتمل</span>
                }
                @else{
                <span style="color:red ; font-size: 14px;"> مرفوض</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="contract">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let el">

              </td>
            </ng-container>

            <ng-container matColumnDef="authorization">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let el">

              </td>
            </ng-container>

            <ng-container matColumnDef="foreign_agency">
              <th mat-header-cell *matHeaderCellDef>{{ 'Foreign Foundation' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.foreign_agency }}</td>
            </ng-container>


            <ng-container matColumnDef="worker_embassy">
              <th mat-header-cell *matHeaderCellDef>{{ 'Worker Embassy' | translate }}</th>
              <td mat-cell *matCellDef="let el">
                {{ el.worker_embassy }}


              </td>
            </ng-container>

            <!-- Call -->
            <ng-container matColumnDef="call">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'call' | translate }}</th>
              <td mat-cell *matCellDef="let el" class="text-center">
                <a class="chat" (click)="call(el.phone_number)">
                  <img src="/assets/call.png" alt="Call">
                </a>
              </td>
            </ng-container>

            <!-- Chat -->
            <ng-container matColumnDef="chat">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'chat' | translate }}</th>
              <td mat-cell *matCellDef="let el" class="text-center">
                <a class="chat" (click)="chat(el.phone_number)">
                  <img src="/assets/chat.png" alt="Chat">
                </a>
              </td>
            </ng-container>
            <ng-container matColumnDef="add_by">
              <th mat-header-cell *matHeaderCellDef>أضيف بواسطة</th>
              <td mat-cell *matCellDef="let el">{{ el.add_by }}

                <br>
                {{formatDate(el.created_at)}}
              </td>
            </ng-container>
            <ng-container matColumnDef="editor">
              <th mat-header-cell *matHeaderCellDef>تم التعديل</th>
              <td mat-cell *matCellDef="let el">
                <ng-container *ngIf="el.editors?.length">
                  <span *ngFor="let editor of el.editors; let i = index">
                    {{ editor }}<br>

                    {{formatDate(el.updated_at)}}
                  </span>
                </ng-container>
                <span *ngIf="!el.editors?.length">-</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="options">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">

                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">

                    <li><a class="dropdown-item" *ngIf='element.status !== 0'
                        (click)='changeClientStatus(element.id, 0)'>{{ 'Under procedure' |
                        translate }}</a></li>
                    <li><a class="dropdown-item" *ngIf='element.status !== 1'
                        (click)='changeClientStatus(element.id, 1)'>{{ "There is a problem" |
                        translate }}</a></li>
                    <li><a class="dropdown-item" *ngIf='element.status !== 2'
                        (click)='changeClientStatus(element.id, 2)'>{{ "A visa has been issued"
                        | translate }}</a></li>

                    <li><a class="dropdown-item" (click)='edit(element)'>
                        {{ "Edit" | translate }} </a></li>

                    @if(isAdmin){
                    <li><a class="dropdown-item" (click)='delete(element.id)'>{{ "Delete" | translate }}</a></li>
                    }
                  </ul>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator
            style="margin-top: 20px; background: #f5f5f5; border: 1px solid #ddd; border-radius: 6px; padding: 10px;"
            [length]="totalItems" [pageSize]="10" (page)="onPaginateChange($event)">
          </mat-paginator>

        </div>

        <div class="row">
          @if (noData) {
          <app-nodata></app-nodata>
          }
        </div>
      </div>
    </div>
  </div>
</div>